import { email } from 'ngrx-forms/validation';
import { BuildValidatorDecorator } from './helpers';

export const Email = BuildValidatorDecorator(email, 'DX.FORMS.VALIDATION.ERRORS.EMAIL');
